import { render, staticRenderFns } from "./UnidadeAdministrativaList.vue?vue&type=template&id=a307bb36"
import script from "./UnidadeAdministrativaList.vue?vue&type=script&lang=js"
export * from "./UnidadeAdministrativaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports